import { createContext } from 'react';

export const BoardIdContext = createContext<string | null>(null);

export const BoardIdProvider = BoardIdContext.Provider;
